import { IconSubtask, IconMapPin } from '@tabler/icons-react';
import {
  Time,
  ItemName,
  GroupName,
  StatusContainer,
  Status,
  ContentValue,
  Value,
  LinkSection,
  Link,
  LocationText,
  People,
  Location,
  Title,
  Avatar,
  ExtraAvatar,
  Container,
  ContentWrap,
  PeopleText,
} from './EventTooltipStyle';

interface EventTooltipPropsType {
  props: any;
  isSubitem: boolean;
}

const EventTooltip = ({ props, isSubitem }: EventTooltipPropsType) => {
  return (
    <Container>
      <Time>{props.timeText}</Time>
      <Title>
        {isSubitem && (
          <span style={{ verticalAlign: 'middle' }}>
            <IconSubtask
              stroke={1.5}
              style={{ minWidth: '15px', maxWidth: '15px', height: '15px', marginRight: '2px' }}
            />
          </span>
        )}
        {props.event.title}
        {isSubitem && (
          <ItemName>{' | ' + props.event.extendedProps?.data?.parentItem?.name}</ItemName>
        )}
      </Title>
      {props.groupSelection.title && (
        <GroupName>{props.event.extendedProps?.data?.group?.title}</GroupName>
      )}
      <ContentWrap>
        {props.event.extendedProps?.data?.status && (
          <StatusContainer $color={props.event.extendedProps?.data?.status?.color}>
            <Status>{props.event.extendedProps?.data?.status?.text}</Status>
          </StatusContainer>
        )}
        {props.event.extendedProps?.data?.text && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.text}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.numbers && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.numbers}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.email && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.email}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.phone && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.phone}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.timeline && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.timeline}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.formula && (
          <ContentValue>
            <Value>{props.event.extendedProps?.data?.formula}</Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.link && (
          <ContentValue>
            <Value>
              <LinkSection>
                <Link
                  target="_blank"
                  href={props.event.extendedProps.data.link?.url}
                  onClick={(e) => e.stopPropagation()}
                  rel="noreferrer"
                >
                  {props.event.extendedProps.data.link?.text}
                </Link>
              </LinkSection>
            </Value>
          </ContentValue>
        )}
        {props.event.extendedProps?.data?.location && (
          <ContentValue>
            <Value>
              <Location>
                <IconMapPin
                  style={{ width: '13px', minWidth: '13px', height: '13px', marginRight: '2px' }}
                />
                <LocationText>{props.event.extendedProps.data.location}</LocationText>
              </Location>
            </Value>
          </ContentValue>
        )}
      </ContentWrap>
      {typeof props.event.extendedProps.data?.people === 'string' ? (
        props.event.extendedProps.data?.people && (
          <PeopleText>
            <ContentValue>{props.event.extendedProps.data?.people}</ContentValue>
          </PeopleText>
        )
      ) : (
        <People>
          {props.event.extendedProps.data?.people?.length &&
            props.event.extendedProps.data.people.map((guest: any, index: number) => {
              if (guest && index < 5) {
                return (
                  <Avatar key={guest.photo_thumb} className="photo-thumb" src={guest.photo_thumb} />
                );
              }
              return null;
            })}
          {props.event.extendedProps.data?.people?.length > 5 && (
            <ExtraAvatar className="photo-thumb">
              +{props.event.extendedProps.data?.people?.length - 5}
            </ExtraAvatar>
          )}
        </People>
      )}
    </Container>
  );
};

export default EventTooltip;
